import { forwardRef } from 'react'
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { useMediaQuery } from '@material-ui/core';
import Close from '@material-ui/icons/Close';

import { useTheme } from '@material-ui/core/styles'

export default function SelectSDocGroupTypeModal({
    open,
    onClose,
    handleButton,
    onChangeSDocGroupTypeID,
    sDocGroupTypeList,
    sDocGroupTypeID,
}) {
    const theme = useTheme()
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'))

    return (
        <Dialog
            maxWidth="md"
            fullWidth
            fullScreen={fullScreen}
            onClose={onClose}
            open={open}
            TransitionComponent={Transition}>
            <DialogTitle style={{ backgroundColor: '#a74345' }}>
                <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center">
                    <Grid className="flex flex-row items-center" component="div">
                        <Grid className="text-white text-lg">เลือกกลุ่มประเภทเครื่องโทรคมนาคม</Grid>
                    </Grid>
                    <IconButton onClick={onClose} style={{ color: '#fff' }}>
                        <Close />
                    </IconButton>
                </Grid>
            </DialogTitle>
            <DialogContent dividers>
                <Grid className="flex flex-col justify-center items-center py-16 w-full">
                    <FormControl className="w-5/6">
                        <InputLabel id="demo-simple-select-label">
                            กลุ่มประเภทเครื่องโทรคมนาคม
                        </InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={sDocGroupTypeID}
                            label="กลุ่มประเภทเครื่องโทรคมนาคม"
                            onChange={onChangeSDocGroupTypeID}>
                            {sDocGroupTypeList.map(group => {
                                return (
                                    <MenuItem key={group.id} value={group.id}>
                                        <em>{group.groupName}</em>
                                    </MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Grid
                    container
                    justifyContent="flex-end"
                    alignItems="center"
                    component="div">
                    <Grid item className="p-3 w-3/12" component="div">
                        <Button
                            fullWidth
                            onClick={handleButton}
                            color="secondary"
                            variant="contained"
                            disabled={!sDocGroupTypeID}>
                            ยืนยันการเลือก
                        </Button>
                    </Grid>
                </Grid>
            </DialogActions>
        </Dialog>
    )
}

const Transition = forwardRef(function Transtition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />
})
